<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>     
            <Timer :formattedTime="formattedTime"/>    
            <template v-slot:header>
                <h5>Input Gadai Elektronik</h5>
            </template>
            <b-form @submit.prevent="calculateMaksimumPinjaman">
                <div class="form-content-wrapper">
                    <b-row>
                        <b-col cols="9" sm="4" >
                            <h6 class="form-title">DATA ANGGOTA</h6>
                        </b-col>
                        <b-col cols="3" :hidden="$companyId == 'PGI' ?false :true">
                            <b-badge :variant="pdfReadAnggota == false  ?'danger' :'primary'" :hidden="seAnggota == null ?true :false" size="sm" @click="openModalSE(seAnggota, 'anggota' ,pdfReadAnggota)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                <i class="fa fa-info px-1"></i>
                            </b-badge>
                        </b-col>
                    </b-row>
                    <b-row class="no-gutters">
                        <b-col cols="6" sm="3">
                            <b-button @click="openSearchAnggotaModal" name="modalSearchAnggotaBtn" variant="pgiBtn" class="mr-2">
                                <i class="fa fa-search mr-2"></i>Pilih Anggota
                            </b-button>
                        </b-col>
                        <b-col>
                            <b-button @click="addAnggota" name="modalAddAnggotaBtn" variant="pgiBtn">
                                <i class="fa fa-plus mr-2"></i>Anggota Baru
                            </b-button>
                        </b-col>
                    </b-row>
                    <StateDetailHandler
                        :isLoading="stateListAnggota.isLoading"
                        :isError="stateListAnggota.isError"
                        :lines="5"
                        @retry="getListAnggota(anggota.no)"
                        class="mt-3"
                    >
                        <DetailSelectAnggota
                            :anggota="anggota"
                            :canEdit="IS_HAVE_PERMISSION_REQUEST_EDIT"
                            :editAnggota="editAnggota"
                            @refresh="getListAnggota"
                            @preview-foto="openPreview"
                            @wa="redirectToWhatsapp"
                            @copy-wa="onCopyUrlWhatsApp"
                            @edit="showEditAnggota"
                            @detail="$bvModal.show('modal-detail-anggota')"
                            @reset-password="$bvModal.show('modal-reset-password')"
                            @edit-identitas="showEditIdentitas"
                            @edit-anggota="showModalConfirmEditAnggota"
                        />
                    </StateDetailHandler>
                    
                    <div class="mb-4" v-show="valUmur == false">
                        <span class="text-danger"><i class="fa fa-warning"></i> Maaf umur nasabah belum 18 tahun, tidak bisa
                            melakukan gadai. </span>
                    </div>
                </div> 
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA BARANG</h6>
                        <b-row>
                            <b-col cols="12" sm="5">
                                <b-form-group label="Jenis Barang"> 
                                    <b-row no-gutters>
                                        <b-col >
                                            <multiselect v-model="input.jenisBarang" :options="optElekJenis" :internal-search="true"
                                            :allow-empty="false" deselect-label="" select-label="" label="name" track-by="id"
                                            placeholder="-- Please select an option --" />
                                        </b-col>
                                        <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ?false :true">
                                            <b-badge :variant="pdfReadJenis == false  ?'danger' :'primary'" :hidden="seJenis == null ?true :false" @click="openModalSE(seJenis, 'jenis',pdfReadJenis)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                <i class="fa fa-info px-1"></i>
                                            </b-badge>
                                        </b-col>
                                    </b-row>
                                </b-form-group>

                                <b-form-group label="Merk Barang">
                                    <b-row no-gutters>
                                        <b-col >
                                            <StateInputHandler
                                                :isLoading="stateMerkBarang.isLoading"
                                                :error="stateMerkBarang.error"
                                                errorMessage="Gagal memuat merk barang."
                                                @retry="getMerkBarang"
                                            >
                                            <multiselect v-model="input.merkBarang" :disabled="isEmptyState(input.jenisBarang) || optElekMerk.length == 0" :options="optElekMerk"
                                                :internal-search="true" :allow-empty="false" deselect-label="" select-label="" label="name"
                                                track-by="id" placeholder="-- Please select an option --" />
                                            
                                                <EmptyStateInput v-if="!isEmptyState(input.jenisBarang) && optElekMerk.length == 0" />
                                            </StateInputHandler>
                                        </b-col>
                                        <b-col cols="3" class="ml-2">
                                            <b-badge :variant="pdfReadMerk == false  ?'danger' :'primary'" :hidden="seMerk == null ?true :false" size="sm" @click="openModalSE(seMerk, 'merk',pdfReadMerk)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                <i class="fa fa-info px-1"></i>
                                            </b-badge>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-row v-if="showSearchModel" class="mb-3">
                                    <b-col >
                                        <b-button @click="modalSearchModel" name="searchModel" variant="pgiBtn" class="mr-2">
                                            <i class="fa fa-search mr-2"></i>Cari Tipe dari Nomor Model
                                        </b-button>
                                    </b-col>
                                </b-row>
                                <b-form-group label="Tipe Barang"  id="gadaiTipeBarang">
                                    <b-row no-gutters>
                                        <b-col >
                                            <StateInputHandler
                                                :isLoading="stateTipeBarang.isLoading"
                                                :error="stateTipeBarang.error"
                                                errorMessage="Gagal memuat tipe barang."
                                                @retry="getTipeBarang"
                                            >
                                                <multiselect id="gadaiTipeBarang" name="gadaiTipeBarang" v-model="input.tipeBarang" :disabled="isEmptyState(input.merkBarang) || optElekTipe.length == 0"
                                                :options="optElekTipe" :internal-search="true" :allow-empty="true" deselect-label=""
                                                select-label="" label="name" track-by="name" placeholder="-- Please select an option --" />
                                            </StateInputHandler>
                                        </b-col>
                                        <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ?false :true">
                                            <b-badge :variant="pdfReadTipe == false  ?'danger' :'primary'" :hidden="seTipe == null ?true :false" size="sm" @click="openModalSE(seTipe, 'tipe',pdfReadTipe)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                <i class="fa fa-info px-1"></i>
                                            </b-badge>
                                        </b-col>
                                    </b-row>
                                    <small class="text-muted">{{ (tipeCreate == null) ?'dibuat pada -' :'dibuat pada '+ tipeCreate }} {{ $helper.isNullOrEmpty(input.tipeBarang) || $helper.isNullOrEmpty(input.tipeBarang.modelNumber) ? '' : ' , ' + input.tipeBarang.modelNumber }}</small>
                                    <EmptyStateInput v-if="!isEmptyState(input.merkBarang) && optElekTipe.length == 0" />

                                    <div v-if="fotoTipeBarangElek.length > 0" class="mt-2">
                                        <b-button class="btn" variant="pgiBtn" @click="()=> $bvModal.show('view-elektronik')">
                                        Lihat Foto Pendukung
                                        </b-button>
                                    </div>
                                </b-form-group>
                                <b-form-group v-if="optElekTahun.length != 0" label="Tahun / Generasi">
                                    <b-row no-gutters>
                                        <b-col >
                                            <b-form-select v-model="input.tahun" name="tahunElektronik" value-field="id" text-field="name" :options="optElekTahun">
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                        <b-col cols="3" class="ml-2">
                                            <b-badge :variant="pdfReadTahun == false  ?'danger' :'primary'" :hidden="seTahun == null ?true :false" size="sm" @click="openModalSE(seTahun, 'tahun',pdfReadTahun)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                <i class="fa fa-info px-1"></i>
                                            </b-badge>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                    
                                <b-form-group v-if="input.jenisBarang != null && input.jenisBarang.id == 2" label="Spesifikasi Laptop">
                                        <b-row no-gutters>
                                            <b-col>
                                                <!-- TODO HARDCODED JENIS BARANG -->
                                                <b-input v-model="input.spesifikasiLaptop" maxlength="200" />
                                            </b-col>
                                            <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ?false :true">
                                                <b-badge :variant="pdfReadSpekLaptop == false  ?'danger' :'primary'" :hidden="seSpekLaptop == null ?true :false" size="sm" @click="openModalSE(seSpekLaptop, 'SpekLaptop',pdfReadSpekLaptop)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                    <i class="fa fa-info px-1"></i>
                                                </b-badge>
                                                <b-link :to="`${$route.path}/surat-edaran/4`" :hidden="$companyId == 'PGI' && role == 'Super Admin' ?false :true" >
                                                    <b-badge size="sm" class="table-button view ml-2" v-b-tooltip.hover title="Setting SE Spesifikasi Laptop" name="jenisBarangViewBtn">
                                                        <i class="fa fa-plus"></i>
                                                    </b-badge>
                                                </b-link>
                                            </b-col>
                                        </b-row>
                                </b-form-group>
                                            
                                <b-form-group label="Kondisi / Grade Barang">
                                        <b-row no-gutters>
                                            <b-col >
                                                <StateInputHandler
                                                    :isLoading="stateGradeBarang.isLoading"
                                                    :error="stateGradeBarang.error"
                                                    errorMessage="Gagal memuat kondisi / grade barang."
                                                    @retry="getGradeBarang"
                                                >
                                                    <b-form-select v-model="input.kondisi" name="gadaiGradeBarangClass" :options="optElekKondisi"
                                                        :disabled="isEmptyState(input.tipeBarang) || optElekKondisi.length == 0">
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="null" disabled>-- Please select an option --
                                                            </b-form-select-option>
                                                        </template>
                                                    </b-form-select>

                                                    <EmptyStateInput v-if="!isEmptyState(input.tipeBarang) && optElekKondisi.length == 0" />
                                                </StateInputHandler>
                                            </b-col>
                                            <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ?false :true">
                                                <b-badge :variant="pdfReadKondisi == false  ?'danger' :'primary'" :hidden="seKondisi != null && showSeKondisi == true ?false :true" size="sm" @click="openModalSE(seKondisi, 'kondisi',pdfReadKondisi)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                    <i class="fa fa-info px-1"></i>
                                                </b-badge>
                                            </b-col>
                                        </b-row>
                                </b-form-group>

                                <b-row v-if="input.merkBarang && input.merkBarang.name && !showSearchModel">
                                    <b-col>
                                        <b-form-group label="No. Model">
                                            <b-form-select v-model="input.modelNumber" name="noModel" :options="optModel">
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-row v-if="input.modelNumber == 'Lainnya'">
                                    <b-col>
                                        <b-form-group label="No. Model Lainnya">
                                            <b-form-input v-model="input.modelNumberLainnya" maxLength="30" name="noModelLainnya"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-form-group v-if="input.jenisBarang != null && input.jenisBarang.id == 2" label="RAM Laptop">
                                        <b-row no-gutters>
                                            <b-col>
                                                <!-- TODO HARDCODED JENIS BARANG -->
                                                    <b-input-group append="GB">
                                                        <b-form-select v-model="input.ram" :options="optRAM" />
                                                    </b-input-group>
                                            </b-col>
                                            <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ?false :true">
                                                <b-badge :variant="pdfReadRamLaptop == false  ?'danger' :'primary'" :hidden="seRamLaptop == null ?true :false" size="sm" @click="openModalSE(seRamLaptop, 'RamLaptop',pdfReadRamLaptop)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                    <i class="fa fa-info px-1"></i>
                                                </b-badge>
                                                <b-link :to="`${$route.path}/surat-edaran/5`" :hidden="$companyId == 'PGI' && role == 'Super Admin' ?false :true">
                                                    <b-badge size="sm" class="table-button view ml-2" v-b-tooltip.hover title="Setting SE RAM Laptop" name="jenisBarangViewBtn">
                                                        <i class="fa fa-plus"></i>
                                                    </b-badge>
                                                </b-link>
                                            </b-col>
                                        </b-row>
                                </b-form-group>
                                
                                <b-form-group v-if="input.jenisBarang != null && input.jenisBarang.id == 2 || input.jenisBarang.id == 69 || input.jenisBarang.id == 73 || input.jenisBarang.id == 77 || input.jenisBarang.id == 81" label="Hardisk Laptop">
                                    <b-row no-gutters>
                                            <b-col >
                                                <b-form-select
                                                    name="gadaiJenisHardisk"
                                                    v-model="input.gadaiJenisHardisk"
                                                    :options="jenisHardisk"
                                                />
                                            </b-col>
                                            <b-col class="ml-2">
                                                <b-form-select v-if="input.gadaiJenisHardisk == null"
                                                :disabled="input.gadaiJenisHardisk == null" />
                                                <b-form-select v-else-if="input.gadaiJenisHardisk == 'HDD / SD'" name="gadaiSizeHardisk"
                                                v-model="input.gadaiSizeHardisk" :options="optHardiskHDD" :disabled="optHardiskHDD.length == 0 ?true :false">
                                                    <template v-slot:first v-if="input.jenisBarang.id == 2">
                                                        <b-form-select-option :value="null" disabled>Pilih HDD / SD</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                                <b-form-select v-else-if="input.gadaiJenisHardisk == 'SSD'" name="gadaiSizeHardisk"
                                                v-model="input.gadaiSizeHardisk" :options="optHardiskSSD" >
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>Pilih SSD</b-form-select-option>
                                                </template>
                                                </b-form-select>
                                            </b-col>
                                
                                            <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ?false :true">
                                                <b-badge :variant="pdfReadHardisk == false  ?'danger' :'primary'" :hidden="seHardisk == null ?true :false" size="sm" @click="openModalSE(seHardisk, 'hardisk',pdfReadHardisk)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                    <i class="fa fa-info px-1"></i>
                                                </b-badge>
                                                <b-link :to="`${$route.path}/surat-edaran/6`" :hidden="$companyId == 'PGI' && role == 'Super Admin' ?false :true" >
                                                    <b-badge size="sm" class="table-button view ml-2" v-b-tooltip.hover title="Setting SE hardisk" name="jenisBarangViewBtn">
                                                        <i class="fa fa-plus"></i>
                                                    </b-badge>
                                                </b-link>
                                            </b-col>
                                    </b-row>
                                </b-form-group>
                                            
                                <b-form-group label="No. IMEI / SN">
                                    <b-row no-gutters>
                                        <b-col >
                                            <b-form-input v-model="input.noImei" name="gadaiNoImei" required></b-form-input>
                                        </b-col>
                                        <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ?false :true">
                                            <b-badge :variant="pdfReadImei == false  ?'danger' :'primary'" :hidden="seImei == null ?true :false" size="sm" @click="openModalSE(seImei, 'Imei',pdfReadImei)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                <i class="fa fa-info px-1"></i>
                                            </b-badge>
                                            <b-link :to="`${$route.path}/surat-edaran/1`" class="ml-2" :hidden="$companyId == 'PGI' && role == 'Super Admin' ?false :true">
                                                <b-badge size="sm" class="table-button view" v-b-tooltip.hover title="Setting SE Imei" name="jenisBarangViewBtn">
                                                    <i class="fa fa-plus"></i>
                                                </b-badge>
                                            </b-link>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                            
                                <b-form-group label="Password"
                                    description="Bila barang gadai tidak menggunakan password, input ini dapat dikosongkan.">
                                    <b-row no-gutters>
                                        <b-col >
                                            <b-form-input v-model="input.password" name="gadaiPassword"></b-form-input>
                                        </b-col>
                                        <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ?false :true">
                                            <b-badge :variant="pdfReadPass == false  ?'danger' :'primary'" :hidden="sePass == null ?true :false" size="sm" @click="openModalSE(sePass, 'Password',pdfReadPass)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                <i class="fa fa-info px-1"></i>
                                            </b-badge>
                                            <b-link :to="`${$route.path}/surat-edaran/2`" :hidden="$companyId == 'PGI' && role == 'Super Admin' ?false :true">
                                                <b-badge size="sm" class="table-button view ml-2" v-b-tooltip.hover title="Setting SE Password" name="jenisBarangViewBtn">
                                                    <i class="fa fa-plus"></i>
                                                </b-badge>
                                            </b-link>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                            
                                <b-form-group label="Warna">
                                    <b-row no-gutters>
                                        <b-col >
                                            <b-form-select v-model="input.warnaBarang" name="gadaiWarnaBarang" :options="optElekWarna">
                                                <template v-slot:first>
                                                    <b-form-select-option :value="null" disabled>-- Please select an option --
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                        <b-col cols="3" class="ml-2" :hidden="$companyId == 'PGI' ?false :true">
                                            <b-badge :variant="pdfReadWarna == false  ?'danger' :'primary'" :hidden="seWarna == null ?true :false" size="sm" @click="openModalSE(seWarna, 'Warna',pdfReadWarna)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                <i class="fa fa-info px-1"></i>
                                            </b-badge>
                                            <b-link :to="`${$route.path}/surat-edaran/3`" class="ml-2" :hidden="$companyId == 'PGI' && role == 'Super Admin' ?false :true">
                                                <b-badge size="sm" class="table-button view" v-b-tooltip.hover title="Setting SE Warna" name="jenisBarangViewBtn">
                                                    <i class="fa fa-plus"></i>
                                                </b-badge>
                                            </b-link>
                                        </b-col>
                                    </b-row>                            
                                </b-form-group>
                                            
                                <!-- <b-form-group label="Kondisi / Kerusakan / Keterangan Lainnya">
                                    <b-form-textarea id="textarea" v-model="input.keterangan" name="gadaiKondisi" rows="3"
                                        max-rows="6"></b-form-textarea>
                                    <span class="smallText text-muted">
                                        * Dapat digunakan juga untuk mencatat detil barang gadai bilamana barang tidak ditemukan
                                        (Menggunakan pilihan ‘Lainnya’)”
                                    </span>
                                </b-form-group> -->
                            </b-col>
                        </b-row>
              
                    <b-form-group>
                        <div>
                            <b-row>
                                <b-col cols="10" sm="4">
                                    <label class="mr-2" for="">Kelengkapan Barang</label>
                                    <span v-if="optKelengkapanBarang.length != 0" :hidden="$companyId == 'PGI' ?false :true">
                                        <b-badge :variant="pdfReadKelengkapan == false  ?'danger' :'primary'" :hidden="seKelengkapan == null ?true :false" size="sm" @click="openModalSE(seKelengkapan, 'kelengkapan' ,pdfReadKelengkapan)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                            <i class="fa fa-info px-1"></i>
                                        </b-badge>
                                    </span>
                                </b-col>
                                <b-col cols=2 >
                                  
                                </b-col>
                            </b-row>
                        </div>

                        <StateCheckboxHandler
                            :isLoading="stateKelengkapanBarang.isLoading"
                            :error="stateKelengkapanBarang.error"
                            errorMessage="Gagal memuat kelengkapan barang."
                            @retry="getKelengkapanBarang"
                        >
                            <template v-if="optKelengkapanBarang.length > 0">
                                <b-form-checkbox-group class="checkbox-group" v-model="input.kelengkapanBarang" name="gadaiKelengkapanBarang">
                                    <div class="d-block" v-for="item in optKelengkapanBarang" :key="item.id">
                                        <b-form-checkbox v-bind:key="item.id"
                                        :value="{ id: item.id, name: item.name }">
                                            {{ item.name }}
                                        </b-form-checkbox>
                                    </div>
                                </b-form-checkbox-group>
                            </template>
                            <template v-else>
                                <div class="text-muted">
                                    Tidak ada kelengkapan dari jenis barang yang dipilih.
                                </div>
                            </template>
                        </StateCheckboxHandler>
                    </b-form-group>
                    <b-form-group label="Spesifikasi Barang (Jenis)">
                        <b-row>
                            <b-col md="6">
                                <span class="text-muted">Penambahan</span>
                                <StateCheckboxHandler
                                    :isLoading="stateSpesifikasiJenisBarang.isLoading"
                                    :error="stateSpesifikasiJenisBarang.error"
                                    errorMessage="Gagal memuat spesifikasi jenis barang."
                                    @retry="getSpesifikasiJenisBarang"
                                >
                                    <template v-if="optElekSpekJenis.penambahan.length > 0">
                                        <b-form-checkbox-group class="checkbox-group mt-1" v-model="input.spesifikasiBarangJenis"
                                            name="gadaiPenambahanSpekJenisBarang">
                                            <div v-for="item in optElekSpekJenis.penambahan" :key="item.id" class="d-block">
                                                <b-row>
                                                    <b-col cols="10">
                                                        <b-form-checkbox v-bind:key="item.id" :value="item.id">
                                                            {{ item.name }}   
                                                        </b-form-checkbox>
                                                    </b-col>
                                                    <b-col cols=2 :hidden="$companyId == 'PGI' ?false :true">
                                                        <b-badge  :variant="item.isViewSE == false  ?'danger' :'primary'" :hidden="item.se == null ?true :false" @click="openModalSE(item.se,'spesifikasiJenis',item.isViewSE,'penambahanSpekJenis',item.id)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                            <i class="fa fa-info px-1"></i>
                                                        </b-badge>
                                                    </b-col>
                                                </b-row>                                  
                                            </div>
                                        </b-form-checkbox-group>
                                    </template>
                                    <template v-else>
                                        <div class="text-muted mb-2">
                                            Tidak ada penambahan spesifikasi dari jenis barang yang dipilih.
                                        </div>
                                    </template>
                                </StateCheckboxHandler>
                            </b-col>
                            <b-col md="6">
                                <span class="text-muted">Pengurangan</span>
                                <StateCheckboxHandler
                                    :isLoading="stateSpesifikasiJenisBarang.isLoading"
                                    :error="stateSpesifikasiJenisBarang.error"
                                    errorMessage="Gagal memuat spesifikasi jenis barang."
                                    @retry="getSpesifikasiJenisBarang"
                                >
                                    <template v-if="optElekSpekJenis.pengurangan.length > 0">
                                        <b-form-checkbox-group class="checkbox-group mt-1" v-model="input.spesifikasiBarangJenis"
                                            name="gadaiPenguranganSpekJenisBarang">
                                            <div class="d-block" v-for="item in optElekSpekJenis.pengurangan" :key="item.id">
                                                <b-row>
                                                    <b-col cols="10">
                                                        <b-form-checkbox
                                                        v-bind:key="item.id" :value="item.id">
                                                        {{ item.name }}
                                                        </b-form-checkbox>
                                                    </b-col>
                                                    <b-col cols="2" :hidden="$companyId == 'PGI' ?false :true">
                                                    <b-badge  :variant="item.isViewSE == false  ?'danger' :'primary'" :hidden="item.se == null ?true :false" @click="openModalSE(item.se,'spesifikasiJenis',item.isViewSE,'penguranganSpekJenis',item.id)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                            <i class="fa fa-info px-1"></i>
                                                        </b-badge>
                                                        <!-- <b-badge :variant="pdfReadTipe == false  ?'danger' :'primary'" :hidden="seTipe == null ?true :false" size="sm" @click="openModalSE(seTipe, 'tipe',pdfReadTipe)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                            <i class="fa fa-info px-1"></i>
                                                        </b-badge> -->
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </b-form-checkbox-group>
                                    </template>
                                    <template v-else>
                                        <div class="text-muted mb-2">
                                            Tidak ada pengurangan spesifikasi dari jenis barang yang dipilih.
                                        </div>
                                    </template>
                                </StateCheckboxHandler>
                            </b-col>
                        </b-row>
                    </b-form-group>
                    <b-form-group label="Spesifikasi Barang (Merk)">
                        <b-row>
                            <b-col md="6">
                                <span class="text-muted">Penambahan</span>
                                <StateCheckboxHandler
                                    :isLoading="stateSpesifikasiMerkBarang.isLoading"
                                    :error="stateSpesifikasiMerkBarang.error"
                                    errorMessage="Gagal memuat spesifikasi merk barang."
                                    @retry="getSpesifikasiMerkBarang"
                                >
                                    <template v-if="optElekSpekMerk.penambahan.length > 0">
                                        <b-form-checkbox-group class="checkbox-group mt-1" v-model="input.spesifikasiBarangMerk"
                                            name="gadaiPenambahanSpekMerkBarangElektronik">
                                            <div class="d-block" v-for="item in optElekSpekMerk.penambahan" :key="item.id">
                                                <b-row>
                                                    <b-col cols="10">
                                                        <b-form-checkbox
                                                            v-bind:key="item.id" :value="item.id">
                                                            {{ item.name }}
                                                        </b-form-checkbox>
                                                    </b-col>
                                                    <b-col cols="2" :hidden="$companyId == 'PGI' ?false :true">
                                                        <b-badge  :variant="item.isViewSE == false  ?'danger' :'primary'" :hidden="item.se == null ?true :false" @click="openModalSE(item.se,'spesifikasiMerk',item.isViewSE,'penambahanSpekMerk',item.id)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                            <i class="fa fa-info px-1"></i>
                                                        </b-badge>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </b-form-checkbox-group>
                                    </template>
                                    <template v-else>
                                        <div class="text-muted mb-2">
                                            Tidak ada penambahan spesifikasi dari merk barang yang dipilih.
                                        </div>
                                    </template>
                                </StateCheckboxHandler>
                            </b-col>
                            <b-col md="6">
                                <span class="text-muted">Pengurangan</span>
                                <StateCheckboxHandler
                                    :isLoading="stateSpesifikasiMerkBarang.isLoading"
                                    :error="stateSpesifikasiMerkBarang.error"
                                    errorMessage="Gagal memuat spesifikasi merk barang."
                                    @retry="getSpesifikasiMerkBarang"
                                >
                                    <template v-if="optElekSpekMerk.pengurangan.length > 0">
                                        <b-form-checkbox-group class="checkbox-group mt-1" v-model="input.spesifikasiBarangMerk"
                                            name="gadaiPenguranganSpekMerkBarangElektronik">
                                            <div class="d-block" v-for="item in optElekSpekMerk.pengurangan" :key="item.id">
                                                <b-row>
                                                    <b-col cols="10">
                                                        <b-form-checkbox
                                                            v-bind:key="item.id" :value="item.id">
                                                            {{ item.name }}
                                                        </b-form-checkbox>
                                                    </b-col>
                                                    <b-col cols="2" :hidden="$companyId == 'PGI' ?false :true">
                                                        <b-badge  :variant="item.isViewSE == false  ?'danger' :'primary'" :hidden="item.se == null ?true :false" @click="openModalSE(item.se,'spesifikasiMerk',item.isViewSE,'penguranganSpekMerk',item.id)" v-b-tooltip.hover title="SE" name="jenisBarangViewBtn">
                                                            <i class="fa fa-info px-1"></i>
                                                        </b-badge>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                        </b-form-checkbox-group>
                                    </template>
                                    <template v-else>
                                        <div class="text-muted mb-2">
                                            Tidak ada pengurangan spesifikasi dari merk barang yang dipilih.
                                        </div>
                                    </template>
                                </StateCheckboxHandler>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PENDUKUNG</h6>
                    <div>
                        <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukung" name="fotoPendukungAddBtn"><i
                                class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                        <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal {{ input.fotoPendukung.length }} Foto
                        </div>

                        <FotoPendukung v-for="item in input.fotoPendukung" v-bind:key="item.index" :fotoPendukung="item"
                            :length="input.fotoPendukung.length" :minLength="minLengthFotoPendukung"
                            @remove="removeFotoPendukung" @showModalCam="openModalCam"
                            @showModalPreview="openModalPreview" :lat="lat" :long="long" isRemove />
                    </div>
                </div>
                <div class="form-content-wrapper">
                    <h6 class="form-title">PROMO</h6>
                    <b-button variant="cancelBtn" @click="checkPromo" :disabled="isGettingPromo">
                        {{ isGettingPromo ? "Mengambil..." : "Cek Promo yang Dapat Digunakan" }}
                        <i class="fa fa-search ml-2"></i>
                    </b-button>
                    <div class="detail-promo-data mt-4" v-if="!isGettingPromo && isPromoRetrieved">
                        <div v-if="optPromo.length == 0" class="text-danger">
                            * Tidak ada promo yang bisa digunakan untuk pemilihan barang gadai ini.
                        </div>
                        <b-form-checkbox-group v-else v-model="input.promo" name="promoList" stacked>
                            <b-form-checkbox class="mb-1" v-for="item in optPromo" v-bind:key="item.id" :value="item.id">{{
                                item.name }}</b-form-checkbox>
                        </b-form-checkbox-group>
                    </div>
                </div>
                <div class="form-content-wrapper" v-if="showDataLainnya && input.merkBarang.name == 'Lainnya'">
                    <h6 class="form-title">HARGA BARANG LAINNYA</h6>
                    <b-form-group label="Nominal Harga">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.nominalHargaLainnya" name="nominalHargaLainnya" required>
                            </b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <h6 class="form-title mt-4">ADMIN FEE LAINNYA</h6>
                    <b-form-group label="Nominal Admin Fee">
                        <b-input-group prepend="Rp.">
                            <b-form-input v-model="input.nominalAdminFeeLainnya" name="nominalAdminFeeLainnya" required>
                            </b-form-input>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="gadaiSubmitBtn" variant="primary" :disabled="isSubmitting">
                        {{ isSubmitting ? "Menghitung..." : "Hitung" }}
                    </b-button>
                </div>
            </b-form>
            <b-modal id="modal-input-anggota" body-class="modal-nopadding" size="xl" title="Input Anggota" hide-footer
                no-close-on-esc no-close-on-backdrop>
                <InputAnggota :isModal="modalAnggota" @submitModalAnggota="inputNewAnggota" :getListAnggota="getListAnggota" />
            </b-modal>
            <b-modal id="modal-edit-anggota" body-class="modal-nopadding" size="xl" title="Edit Anggota" hide-footer
                no-close-on-esc no-close-on-backdrop>
                <EditAnggota :isModal="modalAnggota" :idAnggota="anggota.id" @updateModalAnggota="editNewAnggota" :getListAnggota="getListAnggota" :onToastSuccesEdit="onToastSuccesEdit" />
            </b-modal>
            <b-modal id="modal-detail-anggota" body-class="modal-nopadding" size="xl" title="Detail Anggota"
                no-close-on-backdrop>
                <DetailAnggota :isModal="modalAnggota" :idAnggota="anggota.id" />
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="cancelDetailAnggotaBtn" @click="cancel()">
                        Tutup
                    </b-button>
                </template>
            </b-modal>
            <ModalPilihAnggota @anggota-selected="selectAnggota" />
            <ModalRincian :namaLengkapBarang="namaLengkapBarang" :rincian="rincian" :isSubmitting="isSubmitting"
                :defaultMetodeGadai="input.metodeGadai" :defaultTenor="input.tenor" :jenisPinjaman="JENIS_PINJAMAN"
                @next="calculateConfirmation"
                :isRecalculating="isRecalculating" @change-metode="recalculateSkema" />
            <ModalKonfirmasi :isSubmitting="isSubmitting" :nilaiPinjaman="input.nilaiPinjaman" :anggota="anggota"
                :rincian="rincian" :namaLengkapBarang="namaLengkapBarang"
                :metodeGadai="input.metodeGadai" :tenor="input.tenor" :angsuranPerBulan="angsuranPerBulan"
                @exec-submit="submitGadai" />
            <ModalSukses :rincian="rincian" @done="reset" />
            <ModalWebCam idWebcam="webcam-input-elek" @photoTaken="setResult" />
            <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
            <b-modal id="modal-info-update" title="Update Data Anggota" hide-footer no-close-on-esc no-close-on-backdrop>
                <p>Mohon klik tombol Edit Anggota dan pastikan data anggota sudah sesuai dengan kartu identitas anggota!
                </p>
                <p>
                    <strong>
                        Pastikan alamat (kota, kecamatan, kelurahan) dan foto identitas sudah benar.
                    </strong>
                </p>
                <p>
                    Catatan: Bila data sudah benar semua dari awal, mohon untuk tetap menekan tombol Update ketika Edit
                    Anggota.
                </p>
                <b-button variant="pgiBtn" class="mr-2" @click="showModalEditAnggota()">
                    <i class="fa fa-pencil mr-2"></i>
                    Edit Anggota
                </b-button>
            </b-modal>
            <b-modal id="modal-upgrade-member" title="Upgrade Member" centered hide-footer no-close-on-backdrop
                no-close-on-esc>
                Melakukan upgrade nasabah a/n <strong>{{ anggota.nama }} ({{ anggota.no }})</strong> menjadi member.
                <div class="mt-4 text-right">
                    <b-button variant="pgiBtn" :disabled="isSubmitting" @click="confirmUpgradeMember">
                        Upgrade Member
                    </b-button>
                </div>
            </b-modal>
            <b-modal id="modal-confirm-upgrade" title="Konfirmasi" centered hide-footer no-close-on-backdrop
                no-close-on-esc>
                Konfirmasi upgrade nasabah a/n <strong>{{ anggota.nama }} ({{ anggota.no }})</strong> menjadi member?
                <div class="mt-4 text-right">
                    <b-button variant="pgiBtn" :disabled="isSubmitting" @click="execUpgradeMember">
                        {{ isSubmitting ? "Mengupgrade..." : "Upgrade" }}
                    </b-button>
                </div>
            </b-modal>
            <ModalResetPassword :nasabah="anggota"/>

            <!-- MODAL SHOW SE -->
            <b-modal id="modal-SE-load" class="surat_edaran_modal" size="lg" title="Surat Edaran">
                <b-table id="tableSE" bordered hover show-empty 
                    :fields="fields" 
                    :busy=false
                    :items="activeSE" 
                    :currentPage="currentPage" 
                    :perPage="perPage"
                    :borderless = true
                    :head-variant= null
                    responsive class="mb-3">
                    <template v-slot:header :hidden=true></template>
                    <template v-slot:cell(se)="row">
                        <iframe width="100%" height="700" allowfullscreen :src='$baseFilePath + row.item.filepath' frameborder="0"></iframe>
                    </template>
                </b-table>
                <template>
                    <div class="progress" :hidden="progress == 100 || progress == 0 ?true :false">
                        <div class="progress-bar" role="progressbar" :style="{ width: progress + '%' }" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
                        {{ progress }}%
                        </div>
                    </div>
                </template>
                <br>
                <div class="pagination-wrapper d-flex align-items-center justify-content-center">
                   
                    <b-pagination class="mb-0" :disabled="interval" 
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
                <template #modal-footer>
                    <div class="w-100">
                    </div>
                </template>
            </b-modal>

            <!-- MODAL SHOW SE -->
            <b-modal id="modal-SE" class="surat_edaran_modal" size="lg" title="Surat Edaran">
                <b-table bordered hover show-empty 
                    :fields="fields" 
                    :busy=false
                    :items="activeSE" 
                    :currentPage="currentPage" 
                    :perPage="perPage"
                    :borderless = true
                    :head-variant= null
                    responsive class="mb-3">
                    <template v-slot:header :hidden=true></template>
                    <template v-slot:cell(se)="row">
                        <iframe width="100%" height="700" allowfullscreen :src='$baseFilePath + row.item.filepath' frameborder="0"></iframe>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-center">
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="page"
                    ></b-pagination>
                </div>
                <template #modal-footer>
                    <div class="w-100">
                    </div>
                </template>
            </b-modal>

            <b-modal id="modal-update-telepon" title="Mohon update no telepon anggota" hide-header-close no-close-on-esc no-close-on-backdrop>
                <p class="mb-0">Mohon untuk mengupdate no telepon anggota terlebih dahulu !</p>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                        Lanjutkan Gadai
                    </b-button>
                </template>
            </b-modal>
            <ModalSearchModel :merkId="input.merkBarang && input.merkBarang.id" @model-selected="modelSelected"/>
        </b-card>

    <ModalIdentitas
        :isModal="modalAnggota"
        :idAnggota="anggota.id"
        :dataAnggota="anggota"
        :getListAnggota="getListAnggota"
        :isEdit="isModalEditAnggota"
        titleInformasiEdit="Perubahan identitas dapat dilakukan melalui tombol Edit Identitas di depan."
    />
    <ModalConfirm id="modal-request-edit-no-handphone" title="Konfirmasi Perubahan No Handphone Anggota"
        :isSubmitting="isLoadingReqApproval" desc="Apakah Anda yakin ingin ubah no handphone anggota ini?"
        @submit="handleApproval('no-handphone')" />

    <ModalConfirm id="modal-request-edit-name" title="Konfirmasi Perubahan Nama Anggota" :isSubmitting="isLoadingReqApproval"
        desc="Apakah Anda yakin ingin ubah nama anggota ini?" @submit="handleApproval('name')" />

    <b-modal id="view-elektronik" title="Foto Pendukung" size="lg" 
        no-close-on-backdrop no-close-on-esc >
            <b-form-group>
                <span class="mr-1" v-for="(item, index) in fotoTipeBarangElek" :key="index">
                    <a v-bind:href="item.name" target="_blank">
                        <img width="130px" height="130px" :src="item.name">
                    </a>
                </span>
            </b-form-group>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                Close
            </b-button>
        </template>              
    </b-modal>
    </div>
</template>

<script>
import ModalPilihAnggota from '../ModalPilihAnggota'
import ModalRincian from '../ModalRincian'
import ModalKonfirmasi from '../ModalKonfirmasi'
import ModalSukses from '../ModalSukses'
import InputAnggota from '../../master/anggota/InputAnggota'
import EditAnggota from '../../master/anggota/EditAnggota'
import DetailAnggota from '../../master/anggota/DetailAnggota'
import FotoPendukung from '../../../components/webcam/FotoPendukung'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'
import ModalResetPassword from '../../master/anggota/ModalResetPassword'
import ModalSearchModel from '@/components/gadai/MSearchModel.vue'
import Timer from '@/components/gadai/Timer'

import ModalIdentitas from "../ModalIdentitas.vue";
import StateInputHandler from '@/components/common/StateInputHandler'
import StateCheckboxHandler from '@/components/common/StateCheckboxHandler'
import StateDetailHandler from '@/components/common/StateDetailHandler'
import EmptyStateInput from '@/components/common/EmptyStateInput'
import DetailSelectAnggota from '@/components/anggota/DetailSelectAnggota'
import CONSTANTS from '@/constants'

export default {
    name: 'input-gadai-elektronik',
    components: {
        ModalPilihAnggota,
        ModalRincian,
        ModalKonfirmasi,
        ModalSukses,
        InputAnggota,
        EditAnggota,
        DetailAnggota,
        FotoPendukung,
        ModalWebCam,
        ModalPreview,
        ModalResetPassword,
        ModalSearchModel,
        Timer,
        ModalIdentitas,
        StateInputHandler,
        StateCheckboxHandler,
        EmptyStateInput,
        StateDetailHandler,
        DetailSelectAnggota,
    },
    data() {
        return {
            initStatus: 0,
            isGettingPromo: false,
            isPromoRetrieved: false,
            isSubmitting: false,
            isRecalculating: false,
            role: null,
            shouldResetSelections : false,

            lat:0,
            long:0,

            progress: 0,
            intervalId: null,

            value:70,
            max:100,

            interval:false,

            showSearchModel: false,

            modalAnggota: true,
            editAnggota: false,
            anggota: {
                id: null,
                nama: "-",
                no: "-",
                noMember: null,
                jenisBarang: "-",
                jenisIdentitas: "-",
                noIdentitas: "-",
                noHp: "-",
                noRumah: "-",
                alamat: "-",
                isComplete: false,
                shouldUpdate: false,
                tanggalLahir: "-",
                rekening:[],
                fotoKtp:"",
            },

            rincian: {
                hargaBarang: 0,
                maksimumPinjaman: 0,
                minimumPinjaman: 0,
                perhitunganPromo: null,
                perhitunganKondisi: {},
                perhitunganSpek: [],
                perhitunganBonusGadaiPertama: {},
                perhitunganStatusAnggota: {},
                biayaAdmin: 0,
                noFaktur: "",
                showAlertNoFakturGanda: "false",
                alertNoImei: "",
                alertNoFakturGanda: "",
                alertGadai: "elek",
                warnCpuZ: false,
                isImeiBlacklisted: false,
                disburseType: 0,
            },

            namaLengkapBarang: "",
            angsuranPerBulan: 0,

            input: {
                noImei: null,
                password: "",
                jenisBarang: { id: null, name: null },
                merkBarang: { id: null, name: null },
                tipeBarang: null,
                tahun: null,
                kondisi: null,
                kelengkapanBarang: [],
                spesifikasiBarangJenis: [],
                spesifikasiBarangMerk: [],
                warnaBarang: null,
                keterangan: "",
                promo: [],
                nilaiPinjaman: 0,
                useVoucher: false,
                voucherCode: "",
                ram: 1,
                spesifikasiLaptop: "",
                gadaiJenisHardisk: null,
                gadaiSizeHardisk: null,
                modelNumber: null,
                modelNumberLainnya: null,
                fotoPendukung: [
                    {
                        index: 0,
                        id: 0,
                        checkFotoBarangPendukung: false,
                        fotoBarangPendukungPlaceholder: 'Choose a file',
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                    }
                ],

                nominalHargaLainnya: null,
                nominalAdminFeeLainnya: null,
                disburseType: 0,
                metodeGadai: null,
                tenor: null,
            },

            indexFotoPendukung: 1,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 1,
            activeFotoPreview: "",

            jenisIdentitas: [],
            requiredForDataKerabatAndPihakLain: false,
            tarifSelected: null,
            selected: null,

            optModel:[],
            optElekJenis: [],
            optElekMerk: [],
            optElekTipe: [],
            optElekTahun: [],
            optElekKondisi: [],
            optElekWarna: [],
            optKelengkapanBarang: [],
            optElekSpekJenis: {
                penambahan: [],
                pengurangan: []
            },
            optElekSpekMerk: {
                penambahan: [],
                pengurangan: []
            },
            optPromo: [],
            cabangId: '',
            showDataLainnya: 'false',

            optRAM: [1, 2, 3, 4, 6, 8, 16, 32, 64, 128],

            jenisHardisk: ["HDD / SD", "SSD"],
            optHardiskHDD: ["Pilih HDD / SD","< 199 (128GB)", "200 - 450 (250GB)", "451 - 900 (500GB)", "901 - 1900 (1TB)", "> 1901 (2TB)"],
            optHardiskSSD: ["Pilih SSD","100 - 450 (250GB)", "451 - 900 (500GB)", "901 - 1900 (1TB)", "> 1901 (2TB)"],

            valUmur: true,

            seAnggota : null,
            seJenis : null,
            seMerk : null,
            seTipe : null,
            seKondisi : null,
            seKondisiDariMerk : null,
            showSeKondisi : false,
            seKelengkapan : null,
            seTahun : null,
            seImei : null,
            sePass : null,
            seWarna : null,
            seSpekLaptop : null,
            seRamLaptop : null,
            seHardisk : null,

            activeSE : null,

            pdfReadAnggota: true,
            pdfReadJenis: true,
            pdfReadMerk: true,
            pdfReadTipe: true,
            pdfReadKelengkapan: true,
            pdfReadSpesifikasiJenis: true,
            pdfReadSpesifikasiMerk: true,
            pdfReadKondisi: true,
            pdfReadTahun: true,
            pdfReadImei: true,
            pdfReadPass: true,
            pdfReadWarna: true,
            pdfReadSpekLaptop: true,
            pdfReadRamLaptop: true,
            pdfReadHardisk: true,
    

            slide: 0,
            sliding: null,

            fields: [
                { key: "se", label:"Surat Edaran"},
            ],
            isBusy: true,

            currentPage: 1,
            perPage: 1,
            rows: null,

            tipeCreate : null,   
            
            startTime: null,
            elapsedTime: 0,
            isModalEditAnggota: false,
            stateMerkBarang: {
                isLoading: false,
                error: null,
            },
            stateTipeBarang: {
                isLoading: false,
                error: null,
            },
            stateGradeBarang: {
                isLoading: false,
                error: null,
            },
            stateKelengkapanBarang: {
                isLoading: false,
                error: null,
            },
            stateSpesifikasiJenisBarang: {
                isLoading: false,
                error: null,
            },
            stateSpesifikasiMerkBarang: {
                isLoading: false,
                error: null,
            },
            isLoadingReqApproval: false,
            selectedRow: null,
            stateListAnggota: {
                isLoading: false,
                isError: false,
            },
            fotoTipeBarangElek: [],
        }
    },
    computed:{
        JENIS_PINJAMAN() {
            return CONSTANTS.GADAI.JENIS.ELEKTRONIK
        },
        formattedTime() {
            const minutes = Math.floor(this.elapsedTime / 60000);
            const seconds = Math.floor((this.elapsedTime % 60000) / 1000);
            return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
        },
        isRunning() {
            return this.intervalId !== null;
        },
        IS_HAVE_PERMISSION_REQUEST_EDIT() {
            const hasPermissionEdit = this.$helper.hasPermissionMenuChildren('EDN')
            return hasPermissionEdit;
        },
    },
    methods: {
        
        //----------------- Fungsi Inisialisasi -----------------
        async init() {
            this.initStatus = 0
            this.role = localStorage.getItem('role')
            this.editAnggota = localStorage.getItem("menuChildren").includes("EDA") ? true : false;

            let getJenisElek = this.$axios.get("barang-jenis/elektronik").then(response => {
                this.optElekJenis = response.data
            })

            let getWarnaElek = this.$axios.get("gadai/warna").then(response => {
                this.optElekWarna = response.data.map(item => { return { value: item.id, text: item.name } })
            })

            let seAnggota = this.$axios.get("surat-edaran/list/?menu=anggota&jenis=anggota").then(response => {
         
            if( response.data.length != 0){
                this.seAnggota = response.data
                for(var se of this.seAnggota){
                            if(se.isViewSE == "false"){
                                this.pdfReadAnggota = false
                            }
                        }
            }
            
            })

            let seImei = this.$axios.get("surat-edaran/list/?menu=Imei&jenis=Imei").then(response => {
    
            if(response.data.length != 0){
               this.seImei = response.data
            for(var se of this.seImei){
                            if(se.isViewSE == "false"){
                                this.pdfReadImei = false
                            }
                        }
                    }
            })


            let sePass = this.$axios.get("surat-edaran/list/?menu=Password&jenis=Password").then(response => {
         
            if( response.data.length != 0){
                this.sePass = response.data
            for(var se of this.sePass){
                            if(se.isViewSE == "false"){
                                this.pdfReadPass = false
                            }
                        }
                    }
            })

            let seWarna = this.$axios.get("surat-edaran/list/?menu=Warna&jenis=Warna").then(response => {
         
            if( response.data.length != 0){
                this.seWarna = response.data
            for(var se of this.seWarna){
                            if(se.isViewSE == "false"){
                                this.pdfReadWarna = false
                            }
                        }
                    }
            })

            let seSpekLaptop = this.$axios.get("surat-edaran/list/?menu=SpekLaptop&jenis=SpekLaptop").then(response => {
            if( response.data.length != 0){
                this.seSpekLaptop = response.data
            for(var se of this.seSpekLaptop){
                            if(se.isViewSE == "false"){
                                this.pdfReadSpekLaptop = false
                            }
                        }
                    }
            })

            let seRamLaptop = this.$axios.get("surat-edaran/list/?menu=RamLaptop&jenis=RamLaptop").then(response => {
            if( response.data.length != 0){
                this.seRamLaptop = response.data
            for(var se of this.seRamLaptop){
                            if(se.isViewSE == "false"){
                                this.pdfReadRamLaptop = false
                            }
                        }
                    }
            })

            let seHardisk = this.$axios.get("surat-edaran/list/?menu=hardisk&jenis=hardisk").then(response => {
            if( response.data.length != 0){
                this.seHardisk = response.data
            for(var se of this.seHardisk){
                            if(se.isViewSE == "false"){
                                this.pdfReadHardisk = false
                            }
                        }
                    }
            })

            // Get data bila ada query referensi
            let ref = this.$route.query.ref 
            if(ref != null) {
                
                this.$axios.get("gadai-mobile/antrian/detail/" + ref).then(res => {
               
                    let data = res.data
                    this.selectAnggota(data.nasabah)
                    this.input.jenisBarang = data.jenis
                    this.input.merkBarang = data.merk
                    this.input.tipeBarang = data.tipe
                    this.input.tahun = data.tahun
                    this.input.warnaBarang = data.warna.id
                    this.input.noImei = data.imei
                    this.input.password = data.password

                })

            }

            if(localStorage.getItem("gadaiFromSimulasi") != null ) {

                if (localStorage.getItem("anggotaFromSimulasi") != null) {
                    this.selectAnggota(JSON.parse(localStorage.getItem("anggotaFromSimulasi")))
                    localStorage.removeItem('anggotaFromSimulasi');
                }

                let data = JSON.parse(localStorage.getItem("gadaiFromSimulasi")) 

                this.input.jenisBarang = await data.jenis
                this.input.merkBarang = await data.merk
                this.input.tipeBarang = await data.tipe
                this.input.tahun = await data.tahun
                this.input.kondisi = await data.kondisi
                this.input.noImei = await data.noImei
                this.input.spesifikasiBarangJenis = await data.spesifikasiJenis
                this.input.spesifikasiBarangMerk = await data.spesifikasiMerk
                this.input.modelNumber = await data.modelNumber
                this.input.modelNumberLainnya = await data.modelNumberLainnya
                this.input.metodeGadai = data.metodeGadai || null
                this.input.tenor = data.tenor || null

                localStorage.removeItem('gadaiFromSimulasi');
            }



            navigator.geolocation.getCurrentPosition(
                position => {
                    this.lat = position.coords.latitude
                    this.long = position.coords.longitude
                },
                error => {
                    console.log(error.message);
                },
            )

            Promise.all([getJenisElek, getWarnaElek ,seAnggota,seImei,sePass,seWarna , seSpekLaptop, seRamLaptop, seHardisk]).then(() => {
                this.initStatus = 1
            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })

            this.cabangId = this.$helper.getCabangId()
        },

        reset() {

            this.$bvModal.hide("modal-sukses")
            this.$bvModal.hide("modal-konfirmasi")
            this.$bvModal.hide("modal-rincian")

            if(this.$route.query.ref != null) {
                this.$router.replace("/gadai/elektronik")
            }


            this.anggota.id = null
            this.anggota.nama = "-"
            this.anggota.no = "-"
            this.anggota.noMember = "-"
            this.anggota.jenisIdentitas = "-"
            this.anggota.noIdentitas = "-"
            this.anggota.noHp = "-"
            this.anggota.noRumah = "-"
            this.anggota.alamat = "-"
            this.anggota.statusPembayaran = "",
            this.anggota.rekening = null
            this.anggota.identitas = []

            this.input.jenisBarang = [{ id: null, name: null }]
            this.input.merkBarang = [{ id: null, name: null }]
            this.input.tipeBarang = null
            this.tipeCreate = null
            this.input.tahun = null
            this.input.kondisi = null
            this.input.kelengkapanBarang = []
            this.input.spesifikasiBarangJenis = []
            this.input.spesifikasiBarangMerk = []
            this.input.warnaBarang = null
            this.input.keterangan = ""
            this.input.noImei = ""
            this.input.password = ""
            this.input.promo = []
            this.input.disburseType = 0;
            this.input.fotoPendukung = [
                {
                    id: 0,
                    index: this.indexFotoPendukung,
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null
                }
            ]

            this.input.nominalHargaLainnya = null,
            this.input.nominalAdminFeeLainnya = null
            this.input.useVoucher = false
            this.input.voucherCode = ""
            this.input.metodeGadai = null
            this.input.tenor = null
            this.angsuranPerBulan = 0

            this.input.ram = 1
            this.input.spesifikasiLaptop = ""
            window.scroll(0, 0)

            this.input.gadaiJenisHardisk = null
            this.input.gadaiSizeHardisk = null
            this.valUmur = true

            this.input.nominalHargaLainnya = null,
            this.input.nominalAdminFeeLainnya = null,
            this.showSearchModel = false,
            this.optModel = []
            this.fotoTipeBarangElek = []
        },

        addAnggota() {
            this.isModalEditAnggota = false;
            this.$bvModal.show("modal-input-anggota")
        },

        showEditAnggota() {
            this.isModalEditAnggota = true;
            this.$bvModal.show('modal-edit-anggota')
        },

        showEditIdentitas() {
            this.isModalEditAnggota = false;
            this.$bvModal.show('modal-identitas-list-c')
        },

        openSearchAnggotaModal() {
            this.$bvModal.show("modal-pilih-anggota")
        },

        selectAnggota(item) {
            this.anggota.id = item.id
            this.anggota.nama = item.nama
            this.anggota.no = item.no
            this.anggota.noMember = item.noMember
            // this.anggota.jenisIdentitas = item.jenisIdentitas.name
            // this.anggota.noIdentitas = item.noIdentitas
            if (item.identitas && item.identitas.length > 0) {
                this.anggota.jenisIdentitas = item.identitas[0].jenisIdentitas
                this.anggota.noIdentitas = item.identitas[0].noIdentitas
            }
            this.anggota.noHp = item.noHp
            this.anggota.noRumah = item.noRumah
            this.anggota.alamat = item.alamat
            this.anggota.identitas = item.identitas

            this.anggota.isComplete = item.isComplete
            this.anggota.shouldUpdate = item.shouldUpdateData
            this.anggota.shouldUpdatePhone = item.shouldUpdatePhone
            this.anggota.statusPembayaran = item.statusPembayaran

            this.anggota.fotoKtp = item.detail.fotoKtp

            // calculate umur
            this.anggota.tanggalLahir = item.tanggalLahir

            this.valUmur = this.$helper.validasiUmurNasabah(this.anggota.tanggalLahir)

            if(item.shouldUpdatePhone == true){
                this.$bvModal.show("modal-update-telepon")
            }

            if (this.valUmur == false) {
                return this.$helper.toastErr(this, "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai.")
            }

            if (this.anggota.shouldUpdate == true) {
                this.$bvModal.hide("modal-pilih-anggota")
                this.$bvModal.show("modal-info-update")
            } else {
                this.$bvModal.hide("modal-pilih-anggota")
            }
        },

        showModalEditAnggota() {
            this.$bvModal.show("modal-edit-anggota")
            this.$bvModal.hide("modal-info-update")
        },

        checkPromo() {

            if (this.input.jenisBarang !== null && this.input.merkBarang !== null && this.input.tipeBarang !== null) {

                if (this.optElekTahun.length != 0 && this.input.tahun == null) {
                    this.$helper.toastErr(this, "Mohon lengkapi jenis, merk, tipe, dan tahun barang terlebih dahulu")
                    return
                }

                let path = 'gadai-crud/promo?jenisPinjamanId=1&jenisBarangId=' + this.input.jenisBarang.id + '&merkId=' + this.input.merkBarang.id + '&tipeId=' + this.input.tipeBarang.id + '&cabangId=' + this.cabangId
                if (this.input.tahun != null) {
                    path += "&tahunId=" + this.input.tahun
                }

                this.input.promo = []

                this.isGettingPromo = true
                this.$axios.get(path).then(response => {
                    this.optPromo = response.data
                    this.isPromoRetrieved = true
                })
                    .catch(error => {
                        this.$helper.parseError(this, error)
                    })
                    .finally(() => {
                        this.isGettingPromo = false
                    })

            }
            else {
                this.$helper.toastErr(this, "Mohon lengkapi jenis, merk, dan tipe barang terlebih dahulu")
            }

        },

        recalculateSkema(metodeGadai) {
            this.input.metodeGadai = metodeGadai
            this.isRecalculating = true
            Promise.resolve(this.calculateMaksimumPinjaman()).then(success => {
                if (!success) return
                const skema = metodeGadai == 'angsuran' ? 'angsuran' : 'non angsuran'
                this.$helper.toastSucc(this, `Harga telah disesuaikan ke skema ${skema}.`, 'Penyesuaian Harga')
            }).finally(() => {
                this.isRecalculating = false
            })
        },
        calculateMaksimumPinjaman() {
            // Check all data has been filled
            if (this.anggota.id == null) {
                this.$helper.toastErr(this, "Mohon memilih anggota terlebih dahulu!")
                return
            }

            if (this.anggota.shouldUpdatePhone == true) {
                this.$helper.toastErr(this, "Mohon update no telepon anggota terlebih dahulu!")
                return
            }

            if (this.input.jenisBarang == null || this.input.merkBarang == null || this.input.warnaBarang == null
                || this.input.tipeBarang == null || this.input.kondisi == null
            ) {
                this.$helper.toastErr(this, "Mohon lengkapi data gadai terlebih dahulu!")
                return
            }

            if (this.input.jenisBarang.name == 'Handphone' && this.input.noImei.length != 15) {
                this.$helper.toastErr(this, "Apabila jenis barangnya Handphone, IMEI harus 15 karakter")
                return
            }

            if (this.optElekTahun.length > 0 && this.input.tahun == null) {
                this.$helper.toastErr(this, "Mohon lengkapi data gadai terlebih dahulu!")
                return
            }

            // Check if there is at least one picture attached
            if (this.input.fotoPendukung.length == 1 && this.$helper.isNullOrEmpty(this.input.fotoPendukung[0].activeFotoPendukungBase64)) {
                this.$helper.toastErr(this, "Mohon upload minimal 1 gambar!")
                return
            }

            // Check if all photo row has been filled
            for (var i = 0; i < this.input.fotoPendukung.length; i++) {
                let item = this.input.fotoPendukung[i]
                if (this.$helper.isNullOrEmpty(item.activeFotoPendukungBase64)) {
                    this.$helper.toastErr(this, "Terdapat upload gambar yang kosong, periksa kembali!")
                    return
                }
            }

            // Bila laptop, cek apabila sudah mengisi spek laptop
            if (this.input.jenisBarang.id == 2) { // TODO HARDCODED JENIS BARANG LAPTOP
                if (this.$helper.isNullOrEmpty(this.input.spesifikasiLaptop)) {
                    return this.$helper.toastErr(this, "Mohon mengisi spesifikasi laptop!")
                }
            }

            // Bila laptop, cek apabila sudah mengisi hardisk laptop
            if (this.input.jenisBarang.id == 2 || this.input.jenisBarang.id == 69 || this.input.jenisBarang.id == 73 || this.input.jenisBarang.id == 77 || this.input.jenisBarang.id == 81 ) { // TODO HARDCODED JENIS BARANG LAPTOP
                if (this.$helper.isNullOrEmpty(this.input.gadaiJenisHardisk)) {
                    return this.$helper.toastErr(this, "Mohon mengisi Hardisk laptop!")
                }
            }

            // Bila laptop, cek apabila sudah mengisi size hardisk laptop
            if (this.input.jenisBarang.id == 2) { // TODO HARDCODED JENIS BARANG LAPTOP
                if (this.$helper.isNullOrEmpty(this.input.gadaiSizeHardisk)) {
                    return this.$helper.toastErr(this, "Mohon mengisi size Hardisk laptop!")
                }
            }
            
            // Bila laptop, cek apabila sudah mengisi size hardisk laptop 10" 12" 14" mac
            if (this.input.jenisBarang.id == 69 || this.input.jenisBarang.id == 73 || this.input.jenisBarang.id == 77 || this.input.jenisBarang.id == 81 ) { // TODO HARDCODED JENIS BARANG LAPTOP
                if (this.input.gadaiJenisHardisk == "SSD" && this.input.gadaiSizeHardisk == null) {
                    return this.$helper.toastErr(this, "Mohon mengisi size Hardisk laptop!")
                }
            }

            // Bila umur belum 18 tahun
            if (this.valUmur == false) {
                return this.$helper.toastErr(this, "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai.")
            }

            if (!this.showSearchModel && this.input.modelNumber == null) {
                this.$helper.toastErr(this, "Mohon pilih No. Model!");
                return;
            }

            if (this.input.modelNumber == 'Lainnya' && this.input.modelNumberLainnya == null) {
                this.$helper.toastErr(this, "Mohon isi No. Model!");
                return;
            }

            let payload = this.preparePayload()
            this.isSubmitting = true
            return this.$axios.post("gadai-crud/gadai/elektronik", payload).then(response => {
                this.rincian.isImeiBlacklisted = response.data.isImeiBlacklisted
                if (response.data.noFaktur == 'REFRESH_KONDISI') {
                    this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                    this.input.kondisi = null
                    this.$axios.get(`barang-tipe-v2/kondisi/${this.input.tipeBarang.id}`).then(response => {

                        this.optElekKondisi = response.data.map(item => {
                            return { value: item.id, text: item.name }
                        })

                    })
                } else {
                    let data = response.data
                    this.rincian = data
                    if (response.data.noFakturSuspectGanda != null) {
                        this.rincian.showAlertNoFakturGanda = true
                        this.rincian.alertNoImei = this.input.noImei
                        this.rincian.alertGadai = "elek"
                        this.rincian.alertNoFakturGanda = response.data.noFakturSuspectGanda
                    }

                    if (response.data.shouldWarnCpuZ && response.data.shouldWarnCpuZ == true) {
                        this.rincian.warnCpuZ = true
                    }

                    // Arrange nama lengkap barang
                    this.namaLengkapBarang = `${this.input.jenisBarang.name} - ${this.input.merkBarang.name} - ${this.input.tipeBarang.name}`
                    if (this.input.tahun != null) {
                        let idx = this.optElekTahun.findIndex(item => item.id == this.input.tahun)
                        let namaTahun = this.optElekTahun[idx].name
                        this.namaLengkapBarang += ` - ${namaTahun}`
                    }

                    this.rincian.noImei = this.input.noImei

                    this.$bvModal.show("modal-rincian")
                    return true
                }

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isSubmitting = false
                })

        },

        calculateConfirmation(data) {
            this.input.metodeGadai = data.metodeGadai
            this.input.tenor = data.tenor
            this.angsuranPerBulan = data.angsuranPerBulan || 0

            if (data.nilaiPinjaman % 50000 != 0) {
                this.$helper.toastErr(this, "Pinjaman hanya boleh dalam kelipatan Rp 50.000")
            }
            else {

                let payload = this.preparePayload(data)
        
                this.isSubmitting = true
                this.$axios.post("gadai-crud/gadai/elektronik", payload).then(response => {

                    if (response.data.noFaktur == 'REFRESH_KONDISI') {
                        this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                        this.input.kondisi = null
                        this.$axios.get(`barang-tipe-v2/kondisi/${this.input.tipeBarang.id}`).then(response => {

                            this.optElekKondisi = response.data.map(item => {
                                return { value: item.id, text: item.name }
                            })

                        })
                        this.$bvModal.hide("modal-rincian")
                    } else {
                        
                        let data = response.data
                        this.rincian = data

                        if (this.input.metodeGadai == 'angsuran' && Array.isArray(data.simulasiAngsuran) && data.simulasiAngsuran.length > 0) {
                            this.angsuranPerBulan = data.simulasiAngsuran[0].cicilan
                        }

                        this.$bvModal.show("modal-konfirmasi")
                    }

                })
                    .catch(error => {
                        this.$helper.parseError(this, error)
                    })
                    .finally(() => {
                        this.isSubmitting = false
                    })

            }

        },

        submitGadai() {
            let data = {
                nilaiPinjaman: this.input.nilaiPinjaman,
                useVoucher: this.input.useVoucher,
                voucherCode: this.input.voucherCode,
                disburseType: this.input.disburseType,
            }

            let payload = this.preparePayload(data, true)
            //let payload = this.preparePayload(this.input.nilaiPinjaman, true)
            this.isSubmitting = true
            this.$axios.post("gadai-crud/gadai/elektronik", payload, { timeout: 300000 }).then(response => {

                if (response.data.noFaktur == 'REFRESH_KONDISI') {
                    this.$helper.toastErr(this, "Harga barang baru saja diperbarui HO. Silahkan isi ulang Kondisi / Grade Barang!")
                    this.input.kondisi = null
                    this.$axios.get(`barang-tipe-v2/kondisi/${this.input.tipeBarang.id}`).then(response => {

                        this.optElekKondisi = response.data.map(item => {
                            return { value: item.id, text: item.name }
                        })

                    })
                    this.$bvModal.hide("modal-konfirmasi")
                    this.$bvModal.hide("modal-rincian")
                } else {
                    let data = response.data
                    this.rincian.noFaktur = data.noFaktur

                    this.$bvModal.show("modal-sukses")
                }
            })
                .catch(error => {
                    if(error.response.data.reason.includes('Beneficiary email must be a valid email address')){
                        this.$helper.toastErr(this, 'nasabah tidak memiliki email , mohon isi email terlebih dahulu')
                    }
                    else{
                        this.$helper.parseError(this, error)
                    }
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.resetTime()
                })
        },

        preparePayload(data = null, finalizePayment = false) {
         
            let payload = new FormData()
            payload.append("nasabahId", this.anggota.id)
            payload.append("jenisPinjamanId", 1) // MARK HARDCODE
            payload.append("jenisBarangId", this.input.jenisBarang.id)
            payload.append("merkId", this.input.merkBarang.id)
            payload.append("tipeId", this.input.tipeBarang.id)
            payload.append("kondisiId", this.input.kondisi)
            payload.append("cabangId", this.cabangId)
            payload.append("finalizePayment", finalizePayment)
            payload.append("warnaId", this.input.warnaBarang)
            payload.append("imeiSn", this.input.noImei)

            if (this.input.modelNumber != null) {
                payload.append("modelNumber", (this.input.modelNumber == 'Lainnya') ?this.input.modelNumberLainnya :this.input.modelNumber )
            }

            if(this.input.tipeBarang.noModel != null){
                payload.append("modelNumber", this.input.tipeBarang.noModel)
            }
 
            payload.append("keterangan", this.input.keterangan)

            let nominalHargaLainnya = this.$helper.removeThousandSeparator(this.input.nominalHargaLainnya)
            let nominalAdminFeeLainnya = this.$helper.removeThousandSeparator(this.input.nominalAdminFeeLainnya)

            if (this.$helper.isNotNullAndNotEmpty(this.input.nominalHargaLainnya)) payload.append("hargaBarangLainnya", nominalHargaLainnya)
            if (this.$helper.isNotNullAndNotEmpty(this.input.nominalAdminFeeLainnya)) payload.append("adminFeeLainnya", nominalAdminFeeLainnya)

            // Append all checked spesifikasi
            for (let spek of this.input.spesifikasiBarangJenis) {
                payload.append("spesifikasiId", spek)
            }

            for (let spek of this.input.spesifikasiBarangMerk) {
                payload.append("spesifikasiId", spek)
            }

            // Append promo, if any is selected
            this.input.promo.forEach(promoId => {
                payload.append("promoIds", promoId)
            })

            // Kelengkapan
            if (this.input.kelengkapanBarang.length != 0) {

                this.input.kelengkapanBarang.forEach(item => {
                    payload.append("kelengkapan", item.name)
                })

            }

            // Append tahun, if selected
            if (this.$helper.isNotNullAndNotEmpty(this.input.tahun)) {
                payload.append("tahunId", this.input.tahun)
            }

            // Append peminjaman dan voucher code, if data is not null
            if(data != null) {
              
                this.input.nilaiPinjaman = data.nilaiPinjaman
                this.input.voucherCode = data.voucherCode
                this.input.useVoucher = data.useVoucher
                this.input.disburseType = data.disburseType

                payload.append("jumlahPinjaman", data.nilaiPinjaman)
                payload.append("disburseType", data.disburseType)
                if(data.useVoucher == true) {
                    payload.append("voucherCode", data.voucherCode)
                }

            }

            if (this.input.metodeGadai == 'angsuran') {
                payload.append("scheme", 1)
                payload.append("term", this.input.tenor)
            } else {
                payload.append("scheme", 0)
            }

            // Upload photo and no referensi antrian only if on final step
            if(finalizePayment) {

                let jsonFoto = []
                this.input.fotoPendukung.forEach(function (entry) {
                    jsonFoto.push(entry.activeFotoPendukungBase64)
                })
                payload.append("foto", JSON.stringify(jsonFoto))
                if (this.$helper.isNotNullAndNotEmpty(this.input.password)) {
                    payload.append("password", this.input.password)
                }

                if(this.$route.query.ref != null) {
                    payload.append("noRefAntrian", this.$route.query.ref)
                }

                // RAM dan spek laptop, bila jenis barang laptop
                if (this.input.jenisBarang.id == 2) { // TODO HARDCODED JENIS BARANG LAPTOP
                    payload.append("ram", this.input.ram)
                    payload.append("spesifikasiLaptop", this.input.spesifikasiLaptop)
                    payload.append("gadaiJenisHardisk", this.input.gadaiJenisHardisk)
                    payload.append("gadaiSizeHardisk", this.input.gadaiSizeHardisk)
                }

                if (this.input.jenisBarang.id == 69 || this.input.jenisBarang.id == 73 || this.input.jenisBarang.id == 77 || this.input.jenisBarang.id == 81) { // TODO HARDCODED JENIS BARANG LAPTOP
                    payload.append("gadaiJenisHardisk", this.input.gadaiJenisHardisk)
                    if(this.input.gadaiSizeHardisk == undefined || this.input.gadaiSizeHardisk == null ){
                        payload.append("gadaiSizeHardisk", '-')
                    }
                    else{
                        payload.append("gadaiSizeHardisk", this.input.gadaiSizeHardisk)
                    }
                }

            }
            return payload

        },

        inputNewAnggota() {
            this.$bvModal.hide("modal-confirm-input");
            this.$bvModal.hide("modal-input-anggota");
            this.$helper.toastSucc(this, "Anggota nasabah baru telah berhasil dibuat!");
        },

        editNewAnggota(dataAnggota) {
            //hide modal confirm dan modal anggota

            this.$bvModal.hide("modal-confirm-edit");
            this.$bvModal.hide("modal-edit-anggota");

            this.anggota.id = dataAnggota.idAnggota
            this.anggota.nama = dataAnggota.nama
            this.anggota.no = dataAnggota.noAnggota
            this.anggota.noIdentitas = dataAnggota.noIdentitas
            this.anggota.noHp = dataAnggota.noHp
            this.anggota.noRumah = dataAnggota.noRumah
            this.anggota.alamat = dataAnggota.alamat
            this.anggota.isComplete = dataAnggota.isComplete
            this.anggota.shouldUpdatePhone = dataAnggota.shouldUpdatePhone
            this.anggota.identitas = dataAnggota.identitas
        },

        confirmUpgradeMember() {
            this.$bvModal.show("modal-confirm-upgrade")
        },

        execUpgradeMember() {

            let payload = new FormData()
            payload.append("nasabahId", this.anggota.id)
            payload.append("cabangId", localStorage.getItem("activeCabangId"))

            this.isSubmitting = true
            this.$axios.post("nasabah/upgrade-member", payload).then(res => {

                this.anggota.noMember = res.data.name
                this.$bvModal.hide("modal-upgrade-member")
                this.$bvModal.hide("modal-confirm-upgrade")
                this.$helper.toastSucc(this, "Anggota berhasil diupgrade menjadi member!")

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        openModalCam(index) {
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("webcam-input-elek")
        },

        openModalPreview(index) {
            this.activeFotoPreviewIndex = index
            let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.input.fotoPendukung[idx].fotoBarangPendukungBase64
            this.$bvModal.show("modal-preview-gadai")
        },

        openModalSE(se , jenis , isViewSE , kondisiSpek , idSpek){
            this.activeSE = se
            this.rows = se.length
            
            if(isViewSE == false){
                let payload = new FormData()
                
                let id = 0
                if(jenis == 'jenis'){
                    id = this.input.jenisBarang.id
                    payload.append("id",jenis+id)
                    // payload.append("jenis", "jenis")
                }
                if(jenis == 'merk'){
                    id = this.input.merkBarang.id
                    payload.append("id",jenis+id)
                    // payload.append("jenis", "merk")
                }
                if(jenis == 'tipe'){
                    id = this.input.tipeBarang.id
                    payload.append("id",jenis+id)
                    // payload.append("jenis", "tipe")
                }
                if(jenis == 'kondisi'){
                    // id = this.input.tipeBarang.id
                    // payload.append("id",jenis+id)
                    payload.append("id",this.seKondisi[0].barang)
                    // payload.append("jenis", "kondisi")
                }
                if(jenis == 'kelengkapan'){
                    id = this.input.jenisBarang.id
                    payload.append("id",jenis+id)
                    // payload.append("jenis", "kelengkapan")
                }
                if(jenis == 'spesifikasiJenis'){
                    id = idSpek
                    payload.append("id","spesifikasi"+id)
                    // payload.append("jenis", "spesifikasi")
                }
                if(jenis == 'spesifikasiMerk'){
                    id = idSpek
                    payload.append("id","spesifikasi"+id)
                    // payload.append("jenis", "spesifikasi")
                }
                if(jenis == 'tahun'){
                    id = this.input.tipeBarang.id
                    payload.append("id","tahun"+id)
                    // payload.append("jenis", "tahun")
                }
                if(jenis == 'anggota'){
                    payload.append("id",'anggota')
                    // payload.append("jenis", "anggota")
                }
                if(jenis == 'Imei'){
                    payload.append("id",'Imei')
                    // payload.append("jenis", "anggota")
                }
                if(jenis == 'Password'){
                    payload.append("id",'Password')
                    // payload.append("jenis", "anggota")
                }
                if(jenis == 'Warna'){
                    payload.append("id",'Warna')
                    // payload.append("jenis", "anggota")
                }
                if(jenis == 'SpekLaptop'){
                    payload.append("id",'SpekLaptop')
                    // payload.append("jenis", "anggota")
                }
                if(jenis == 'RamLaptop'){
                    payload.append("id",'RamLaptop')
                    // payload.append("jenis", "anggota")
                }
                if(jenis == 'hardisk'){
                    payload.append("id",'hardisk')
                    // payload.append("jenis", "anggota")
                }
                this.$axios.post(`surat-edaran/view`, payload).then(() => {
                    if(jenis == 'anggota'){
                        this.pdfReadAnggota = true
                    }
                    if(jenis == 'jenis'){
                        this.pdfReadJenis = true
                    }
                    if(jenis == 'merk'){
                        this.pdfReadMerk = true
                    }
                    if(jenis == 'tipe'){
                        this.pdfReadTipe = true
                    }
                    if(jenis == 'kondisi'){
                        this.pdfReadKondisi = true
                    }
                    if(jenis == 'tahun'){
                        this.pdfReadTahun = true
                    }
                    if(jenis == 'kelengkapan'){
                        this.pdfReadKelengkapan = true
                    }
                    if(jenis == 'spesifikasiJenis'){
                        if(kondisiSpek == 'penambahanSpekJenis'){
                            let idx = this.optElekSpekJenis.penambahan.findIndex(item => item.id == idSpek)
                            this.optElekSpekJenis.penambahan[idx].isViewSE = true
                        }
                        if(kondisiSpek == 'penguranganSpekJenis'){
                            let idx = this.optElekSpekJenis.pengurangan.findIndex(item => item.id == idSpek)
                            this.optElekSpekJenis.pengurangan[idx].isViewSE = true
                        }
                    }
                    if(jenis == 'spesifikasiMerk'){
                        if(kondisiSpek == 'penambahanSpekMerk'){
                            let idx = this.optElekSpekMerk.penambahan.findIndex(item => item.id == idSpek)
                            this.optElekSpekMerk.penambahan[idx].isViewSE = true
                        }
                        if(kondisiSpek == 'penguranganSpekMerk'){
                            let idx = this.optElekSpekMerk.pengurangan.findIndex(item => item.id == idSpek)
                            this.optElekSpekMerk.pengurangan[idx].isViewSE = true
                        }
                    }
                    if(jenis == 'Imei'){
                        this.pdfReadImei = true
                    }
                    if(jenis == 'Password'){
                        this.pdfReadPass = true
                    }
                    if(jenis == 'Warna'){
                        this.pdfReadWarna = true
                    }
                    if(jenis == 'SpekLaptop'){
                        this.pdfReadSpekLaptop = true
                    }
                    if(jenis == 'RamLaptop'){
                        this.pdfReadRamLaptop = true
                    }
                    if(jenis == 'hardisk'){
                        this.pdfReadHardisk = true
                    }
                })

                this.$bvModal.show("modal-SE-load")
            }else{
                this.$bvModal.show("modal-SE")
            }
            

           
        },

        async setResult(result) {
            //letakin ke null masing2
           
            let formattedDate = this.$helper.formatTanggalDMY()
            let waktu = this.$helper.waktu24()
        
            //resize image
           var newResult = await this.$helper.resizeImage(result)

           //add timestamp & location
           let img = new Image()
           img.src = newResult
           img.onload = () => {
               let canvas = document.createElement('canvas')
               let ctx = canvas.getContext('2d')
               canvas.setAttribute("width", img.width);
               canvas.setAttribute("height", img.height);
               ctx.drawImage(img, 0, 0,)
               ctx.font = "14pt Arial";
               ctx.fillStyle = "#ffffff"; //<======= here
               ctx.fillText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
               ctx.strokeText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
               ctx.fillText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
               ctx.strokeText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
               let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)

               let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex);
                this.input.fotoPendukung[idx].fotoBarangPendukungBase64 = newBase64Str
                this.input.fotoPendukung[idx].activeFotoPendukungBase64 = newBase64Str
                this.input.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
                this.input.fotoPendukung[idx].checkFotoBarangPendukung = true
           }
        },

        // async setResult(result) {
        //     //letakin ke null masing2
        //     var newResult = await this.$helper.resizeImage(result)
        //     let idx = this.input.fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex);
        //     this.input.fotoPendukung[idx].fotoBarangPendukungBase64 = newResult
        //     this.input.fotoPendukung[idx].activeFotoPendukungBase64 = newResult
        //     this.input.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
        //     this.input.fotoPendukung[idx].checkFotoBarangPendukung = true
        // },

        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        addFotoPendukung() {
            if (this.input.fotoPendukung.length < 30) {
                this.input.fotoPendukung.unshift({
                    id: 0,
                    index: this.indexFotoPendukung,
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null
                })
                this.indexFotoPendukung++;
            } else {
                this.fotoPendukungError = true;
            }
        },

        removeFotoPendukung(index) {
            this.input.fotoPendukung = this.input.fotoPendukung.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },

        modalSearchModel(){
            this.input.noModel
            this.model = []

            this.$bvModal.show("modal-search-model")
        },

        modelSelected(item){
      
            this.optElekTipe = [];
            this.optElekTipe.push(item);
            this.input.tipeBarang = item
            
            this.$bvModal.hide("modal-search-model")
        },

        //Fungsi modal review SE
        onSlideStart() {
        this.sliding = true
        },
        onSlideEnd() {
            this.sliding = false
        },

         //----------------- Fungsi Lain-lain -----------------
        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        onPageChange(){
            this.interval = true
           
            this.intervalId = null
            this.progress = 0
           this.intervalId = setInterval(() => {
            this.progress += 10;
            if (this.progress >= 100) {
                clearInterval(this.intervalId);
            }
            }, 500);

            setTimeout(this.page,5000)
        },

        page(){
            this.interval = false
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * 1 + 1
            limit = (this.currentPage-1) * 1 + 1
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },
        start() {
            if (!this.isRunning) {
                this.startTime = Date.now() - this.elapsedTime;
                this.intervalId = setInterval(() => {
                this.elapsedTime = Date.now() - this.startTime;
                }, 10);
            }
        },
        pause() {
            clearInterval(this.intervalId);
            this.intervalId = null;
       
        },
        resetTime() {
            // this.pause();
            this.elapsedTime = 0;
            this.startTime = null;
            this.startTime = Date.now() - this.elapsedTime;
            this.intervalId = setInterval(() => {
            this.elapsedTime = Date.now() - this.startTime;
            }, 10);
            localStorage.removeItem("stopwatch");
        },

        openPreview(foto){
            this.activeFotoPreview = foto
            this.$bvModal.show("modal-preview-gadai")
        },

        redirectToWhatsapp(number) {
            if (!number || number === '-' || number.trim() === '') {
                return;
            }

            const formatted = number.startsWith('0') 
            ? '62' + number.substring(1) 
            : number;

            window.open(`https://wa.me/${formatted}`, '_blank');
        },

        onCopyUrlWhatsApp(number) {
            if (!number || number === '-' || number.trim() === '') {
                console.error('Nomor HP tidak valid untuk disalin.');
                return;
            }

            const formatted = number.startsWith('0') 
                ? '62' + number.substring(1) 
                : number;
            
            const urlToCopy = `https://wa.me/${formatted}`;

            navigator.clipboard.writeText(urlToCopy).then(() => {
                this.$helper.toastSucc(this, "Link WhatsApp berhasil disalin!")
            }).catch(err => {
                this.$helper.toastErr(this, "Gagal menyalin link.")
                console.error('Gagal menyalin teks: ', err);
            });
        },

        getListAnggota(noAnggota) {
            this.stateListAnggota.isLoading = true;
            this.stateListAnggota.isError = false;

            this.$axios.get(`nasabah/findForGadai`, {
                params: {
                    query: noAnggota,
                    searchBy: 3,
                    page: 0,
                    size: 10,
                }
            }).then(response => {
                const data = response.data.data[0];
                this.selectAnggota(data);
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.stateListAnggota.isError = true;
            })
            .finally(() => {
                this.stateListAnggota.isLoading = false;
            })
        },
        onToastSuccesEdit() {
            this.$helper.toastSucc(this, "Identitas berhasil diupdate");
        },
        getMerkBarang() {
            const idJenisBarang = this.input.jenisBarang.id;
            this.optElekMerk = [];
            this.stateMerkBarang.isLoading = true;
            this.$axios.get(`barang-merk/jenis/${idJenisBarang}`).then(response => {
                this.optElekMerk = response.data
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateMerkBarang.error = errorMessage;
            }).finally(() => {
                this.stateMerkBarang.isLoading = false;
            }) 
        },
        getTipeBarang() {
            const idMerkBarang = this.input.merkBarang.id;
            this.optElekTipe = [];
            this.stateTipeBarang.isLoading = true;
            this.$axios.get(`barang-tipe-v2/merk/${idMerkBarang}`).then(response => {
                this.optElekTipe = response.data.types;
                if (response.data.models.length == 0) {
                    this.showSearchModel = true
                } else {
                    this.showSearchModel = false
                    this.optModel = response.data.models;
                    this.optModel.push('Lainnya')
                }
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateTipeBarang.error = errorMessage;
            }).finally(() => {
                this.stateTipeBarang.isLoading = false;
            })
        },
        getGradeBarang() {
            const idTipeBarang = this.input.tipeBarang.id;
            this.optElekKondisi = [];
            this.stateGradeBarang.isLoading = true;
            this.$axios.get(`barang-tipe-v2/kondisi/${idTipeBarang}`).then(response => {
                this.optElekKondisi = response.data.filter(item => item.isActive == true)
                this.optElekKondisi = this.optElekKondisi.map(item => {
                    return { value: item.id, text: item.name, suratEdaran: item.suratEdaran }
                })
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateGradeBarang.error = errorMessage;
            }).finally(() => {
                this.stateGradeBarang.isLoading = false;
            })
        },
        getKelengkapanBarang() {
            const idJenisBarang = this.input.jenisBarang.id;
            this.optKelengkapanBarang = []
            this.stateKelengkapanBarang.isLoading = true;

            this.$axios.get(`barang-jenis/kelengkapan?jenisId=${idJenisBarang}`).then(response => {
                for (var x of response.data) {
                    if (x.isActive == true) {
                        this.optKelengkapanBarang.push({
                            id: x.id,
                            name: x.name,
                            se: (x.suratEdaran.length != 0) ? x.suratEdaran : null  
                        })
                    }
                }          
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateKelengkapanBarang.error = errorMessage;
            }).finally(() => {
                this.stateKelengkapanBarang.isLoading = false;
            })
        },
        getSpesifikasiJenisBarang() {
            const idJenisBarang = this.input.jenisBarang.id;
            this.optElekSpekJenis.penambahan = []
            this.optElekSpekJenis.pengurangan = []
            this.stateSpesifikasiJenisBarang.isLoading = true;

            this.$axios.get(`barang-jenis/spesifikasi?jenisId=${idJenisBarang}`).then(response => {
                for (var x of response.data.penambahan) {
                    if (x.isActive == true) {
                        var isViewSE = true
                        for(var file of x.suratEdaran){
                            if (file.isViewSE  == "false"){
                                isViewSE = false
                            }
                        }
                        this.optElekSpekJenis.penambahan.push({
                            id: x.id,
                            name: x.name,
                            se: (x.suratEdaran.length != 0) ? x.suratEdaran : null,
                            isViewSE: isViewSE
                        })
                    }
                }
                for (var x of response.data.pengurangan) {
                    if (x.isActive == true) {
                        var isViewSE = true
                        for(var file of x.suratEdaran){
                            if (file.isViewSE  == "false"){
                                isViewSE = false
                            }
                        }
                        this.optElekSpekJenis.pengurangan.push({
                            id: x.id,
                            name: x.name,
                            se: (x.suratEdaran.length != 0) ? x.suratEdaran : null,
                            isViewSE: isViewSE
                        })
                    }
                }
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateSpesifikasiJenisBarang.error = errorMessage;
            }).finally(() => {
                this.stateSpesifikasiJenisBarang.isLoading = false;
            })
        },
        getSpesifikasiMerkBarang() {
            const idMerkBarang = this.input.merkBarang.id;
            this.optElekSpekMerk.penambahan = [];
            this.optElekSpekMerk.pengurangan = [];
            this.stateSpesifikasiMerkBarang.isLoading = true;

            this.$axios.get(`barang-merk/spesifikasi?merkId=${idMerkBarang}`).then(response => {
                for (var x of response.data.penambahan) {
                    if (x.isActive == true) {
                        var isViewSE = true
                        for(var file of x.suratEdaran){
                            if (file.isViewSE  == "false"){
                                isViewSE = false
                            }
                        }

                        this.optElekSpekMerk.penambahan.push({
                            id: x.id,
                            name: x.name,
                            se: (x.suratEdaran.length != 0) ?x.suratEdaran :null,
                            isViewSE: isViewSE,
                            fotoSpesifikasi: x.fotoSpesifikasi,
                            isActive: x.isActive,
                            nominalAngka: x.nominalAngka,
                            nominalPersen: x.nominalPersen,
                        })
                    }
                }

                for (var x of response.data.pengurangan) {
                    if (x.isActive == true) {
                        var isViewSE = true
                        for(var file of x.suratEdaran){
                            if (file.isViewSE  == "false"){
                                isViewSE = false
                            }
                        }
                        
                        this.optElekSpekMerk.pengurangan.push({
                            id: x.id,
                            name: x.name,
                            se: (x.suratEdaran.length != 0) ?x.suratEdaran :null,
                            isViewSE: isViewSE,
                            fotoSpesifikasi: x.fotoSpesifikasi,
                            isActive: x.isActive,
                            nominalAngka: x.nominalAngka,
                            nominalPersen: x.nominalPersen,
                        })
                    }
                }
            }).catch((error) => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateSpesifikasiMerkBarang.error = errorMessage;
            }).finally(() => {
                this.stateSpesifikasiMerkBarang.isLoading = false;
            })
        },
        isEmptyState(fieldValue) {
            if (!fieldValue) return true;
            const selectedOption = Array.isArray(fieldValue) ? fieldValue[0] : fieldValue;
            return !selectedOption || (selectedOption.id === null && selectedOption.name === null);
        },
        showModalConfirmEditAnggota(value) {
            this.selectedRow = value;
            
            if (this.$helper.isNullOrEmpty(value.notes)) {
                this.$helper.toastErr(this, "Mohon isi alasan terlebih dahulu.")
                return
            }

            if (value.key === 'no-handphone') {
                const isOldValueX = value.oldValue && String(value.oldValue).toLowerCase().startsWith('x');
                
                if (!isOldValueX && this.$helper.isNullOrEmpty(value.attachments)) {
                    this.$helper.toastErr(this, "Mohon isi foto pendukung terlebih dahulu.")
                    return
                }
                
                this.$bvModal.show('modal-request-edit-no-handphone')
            }

            if (value.key === 'name') {
                this.$bvModal.show('modal-request-edit-name')
            }
        },
        handleApproval(field) {
            const value = this.selectedRow;
            const cabangId = localStorage.getItem('activeCabangId');

            const payload = new URLSearchParams();

            if (field === 'no-handphone') {
                const attachmentsValue = Array.isArray(value.attachments) 
                    ? JSON.stringify(value.attachments) 
                    : value.attachments;
                    
                payload.append('attachments', attachmentsValue);
            }

            let dataType = '';
            if (field === 'no-handphone') {
                dataType = 'no_handphone_sekarang'
            }

            if (field === 'name') {
                dataType = 'nama'
            }

            this.isLoadingReqApproval = true

            const params = {
                dataType: dataType,
                value: value.newValue,
                note: value.notes,
                nasabahId: value.row.id,
                cabangId: cabangId,
            };

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
            };

            this.$axios.post('/nasabah/request-update-data', payload, { 
                params: params, 
                headers: headers 
            })
            .then(response => {
                this.$helper.toastSucc(this, response.data.name)
                if (field === 'no-handphone') {
                    this.$bvModal.hide('modal-approval-no-handphone')
                    this.$bvModal.hide('modal-request-edit-no-handphone')
                }

                if (field === 'name') {
                    this.$bvModal.hide('modal-approval-name')
                    this.$bvModal.hide('modal-request-edit-name')
                }
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadingReqApproval = false;
            })
        }
    },

    watch: {

        'input.noImei': function (newVal){
            this.input.noImei = newVal.replace(/\s/g, '');
        },

        'input.jenisBarang': function (newVal) {
            if(newVal.id==2){
                this.jenisHardisk = ["HDD / SD", "SSD"]
                this.optHardiskSSD = ["100 - 450 (250GB)", "451 - 900 (500GB)", "901 - 1900 (1TB)", "> 1901 (2TB)"]
                this.optHardiskHDD = ["< 199 (128GB)", "200 - 450 (250GB)", "451 - 900 (500GB)", "901 - 1900 (1TB)", "> 1901 (2TB)"]
                this.input.gadaiJenisHardisk=null
            }
            else if(newVal.id == 69 || newVal.id == 73 || newVal.id == 77 || newVal.id == 81){
                this.jenisHardisk = ["HDD / SD", "SSD"]
                this.optHardiskSSD = [
                                        "≤ 128 (128GB)",
                                        "129 - 256 (256GB)",
                                        "257 - 512 (512GB)",
                                        "513 - 1000 (1TB)",
                                        "1001 - 2000 (2TB)",
                                    ]
                this.optHardiskHDD = []
                this.input.gadaiJenisHardisk=null
            }
          
            // this.optElekMerk = []
            // this.input.merkBarang = { id: null, name: null }

          if(this.shouldResetSelections == true){

              this.optElekMerk = []
              this.input.merkBarang = { id: null, name: null }
              
              this.optKelengkapanBarang = []
              this.input.kelengkapanBarang = []
              
              this.optPromo = []
              this.input.promo = []
              this.isPromoRetrieved = false
              
              this.optElekSpekJenis = {
                  penambahan : [],
                  pengurangan : []
                }
                
                this.input.spesifikasiBarangJenis = []
                
                this.seMerk = null
                this.seTipe = null
                this.seKondisi = null
                this.showSeKondisi = null
            }

            if (newVal == null) { return }

            if (newVal.id != undefined) {

                if (this.input.jenisBarang.name.startsWith('Lainnya')) {
                    this.showDataLainnya = true
                }
                // Lookup Merk
                this.getMerkBarang();

                // Loojup SE jenis
                this.$axios.get(`barang-jenis/${newVal.id}`).then(response => {
                    if(response.data.suratEdaran.length != 0){
                        this.seJenis = response.data.suratEdaran
                        
                        for(var se of this.seJenis){
                            if(se.isViewSE == "false"){
                                this.pdfReadJenis = false
                            }
                        }
                    }else{
                        this.seJenis = null
                    }
                })

                // Lookup Kelengkapan Barang
                this.getKelengkapanBarang();


                // LookUP Se Kelengkapan
                this.$axios.get('/surat-edaran/list/?menu=kelengkapan'+newVal.id+'&jenis=kelengkapan').then(response => {
                    if(response.data.length !=0 ){
                            this.seKelengkapan = response.data
                            for(var file of this.seKelengkapan){
                                if(file.isViewSE == "false"){
                                    this.pdfReadKelengkapan = false
                                }
                            }
                        }   
                })
                

                // Lookup Spek Jenis
                this.getSpesifikasiJenisBarang();
            }

            if (newVal != null && this.anggota.id != null) {
               
               this.$axios.get(`/gadai-crud/check-gadai-limits?nasabahId=${this.anggota.id}&jenisBarangId=${newVal.id}`).then(() => {

               })
               .catch(error => {
                   this.$helper.parseError(this, error)
               })
           }

        },

        'input.merkBarang': function (newVal) {
    
            if(this.shouldResetSelections == true){
    
                this.optElekTipe = []
                this.input.tipeBarang = null
                this.tipeCreate = null
                
                this.optElekSpekMerk = {
                    penambahan: [],
                    pengurangan: []
                }
                
                this.seTipe = null
                this.seKondisi = null
                this.showSeKondisi = false
                this.showSearchModel = false
                this.input.modelNumber = null
                this.optModel = []
            }
            this.shouldResetSelections = true
            if (newVal.id == undefined) { return }

            if (newVal.id != undefined) {
                
                // Loojup SE Merk
                this.$axios.get(`barang-merk/${newVal.id}`).then(response => {
                    if(response.data.suratEdaran.length != 0){
                        this.seMerk = response.data.suratEdaran
                        for(var se of this.seMerk){
                            if(se.isViewSE == "false"){
                                this.pdfReadMerk = false
                            }
                        }
                    }else{
                        this.seMerk = null
                    }

                    if(response.data.kondisi[0].suratEdaran.length != 0){
                        let suratEdaranKondisi = []
                        for(var se of response.data.kondisi[0].suratEdaran){
                            suratEdaranKondisi.push(se)
                                if(se.isViewSE == "false"){
                                    this.pdfReadKondisi = false
                                }
                        }

                        this.seKondisi = suratEdaranKondisi
                        this.seKondisiDariMerk = true
                    }else{
                        this.seKondisi = null
                    }

                })

                // Lookup Tipe
                this.getTipeBarang();

                // Lookup Spek Merk
                this.getSpesifikasiMerkBarang();
            }

        },

        'input.tipeBarang': function (newVal) {

            this.tipeCreate = null
            
            if(this.shouldResetSelections == true) {

                this.optElekTahun = []
                this.input.tahun = null

                this.optElekKondisi = []
                this.input.kondisi = null

                this.optPromo = []
                this.input.promo = []
                this.isPromoRetrieved = false

            }

            this.shouldResetSelections = true

            this.showSeKondisi = true

            if (newVal == null) { return }

            if (newVal != null) {
                // Lookup Tahun
                // this.$axios.get(`barang-tipe-v2/tahun/${newVal.id}`).then(response => {
                //     this.optElekTahun = response.data
                // })

                this.$axios.get(`barang-tipe-v2/${newVal.id}`).then(response => {
                    let date = null
                    this.fotoTipeBarangElek = response.data.foto || []
                    if(response.data.createdAt != null){
                        date = response.data.createdAt
                        this.tipeCreate =  this.$helper.formatTanggalDMY(date)
                    }else{
                        this.tipeCreate = null
                    }
                    if(response.data.suratEdaran.length != 0){
                       let suratEdaran = []
                       let suratEdaranKondisi = []
                       let suratEdaranTahun = []
                            for(var se of response.data.suratEdaran){
                            if(se.jenis == null || se.jenis == "tipe"){
                                suratEdaran.push(se)
                                if(se.isViewSE == "false"){
                                    this.pdfReadTipe = false
                                }
                            }
                            if(se.jenis == "kondisi"){
                                suratEdaranKondisi.push(se)
                                if(se.isViewSE == "false"){
                                    this.pdfReadKondisi = false
                                }
                                this.seKondisiDariMerk = false
                            }
                            if(se.jenis == "tahun"){
                                suratEdaranTahun.push(se)                       
                                if(se.isViewSE == "false"){                             
                                    this.pdfReadTahun = false
                                }
                            }
                        }
                       this.seTipe = suratEdaran
                       if(suratEdaranKondisi != null && suratEdaranKondisi.length != 0){
                           this.seKondisi = suratEdaranKondisi
                       }
                       this.seTahun = suratEdaranTahun
                       this.showSeKondisi = true
                    }else{
                        this.seTipe = null
                    }
                    if (response.data.hasTahun == true) {
                        // Lookup Tahun
                        this.$axios.get(`barang-tipe-v2/barang-tahun/${newVal.id}`).then(response => {     
                            for (var x of response.data) {
                                if (x.isActive == true) {
                                    this.optElekTahun.push({
                                        id: x.id,
                                        name: x.tahun
                                    })
                                }
                            }
                        })
                    }
                })
            
                // Lookup Kondisi
                this.getGradeBarang();
            }
        },

        'input.tahun': function () {

            if(this.shouldResetSelections == true) {
                this.optPromo = []
                this.input.promo = []
                this.isPromoRetrieved = false
            }

        },

        "input.nominalHargaLainnya": function (newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalHargaLainnya = result);
        },

        "input.nominalAdminFeeLainnya": function (newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.input.nominalAdminFeeLainnya = result);
        },

        'input.gadaiJenisHardisk': function (newVal) {
            if (newVal == 'HDD / SD') {
                this.input.gadaiSizeHardisk = null
            } else if (newVal == 'SSD') {
                this.input.gadaiSizeHardisk = null
            }
        },

        'anggota.id': function (newVal) {
            if (newVal == null) {return}
            if (newVal && this.input.jenisBarang.id != null) {
               
                this.$axios.get(`/gadai-crud/check-gadai-limits?nasabahId=${newVal}&jenisBarangId=${this.input.jenisBarang.id}`).then(() => {
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
            }

        }
    },
    created(){
        this.resetTime()
        this.start()
        this.init()
    }
}
</script>
